import { NodeViewWrapper } from '@tiptap/react';
import { useState, useRef, useEffect, useCallback } from 'react';

import styles from './styles.module.css';

const ImageNodeView = ({ node, updateAttributes, selected }) => {
  const { src, alt, width } = node.attrs;
  const imgRef = useRef(null);
  const startX = useRef(0);
  const startWidth = useRef(0);
  const [isResizing, setIsResizing] = useState(false);

  const onResizeStart = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      startX.current = e.clientX;
      startWidth.current = imgRef.current?.offsetWidth ?? width ?? 300;
      setIsResizing(true);
    },
    [width],
  );

  useEffect(() => {
    if (!isResizing) return;
    const onMove = (e) => {
      const newW = Math.max(60, startWidth.current + (e.clientX - startX.current));
      updateAttributes({ width: Math.round(newW) });
    };
    const onUp = () => setIsResizing(false);
    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onUp);
    return () => {
      window.removeEventListener('mousemove', onMove);
      window.removeEventListener('mouseup', onUp);
    };
  }, [isResizing, updateAttributes]);

  const imgStyle = {
    display: 'block',
    width: width ? `${width}px` : 'auto',
    maxWidth: '100%',
    outline: selected ? '2px solid var(--color-primary40)' : '2px solid transparent',
    outlineOffset: 1,
    borderRadius: 2,
    cursor: 'default',
    userSelect: 'none',
  };

  return (
    <NodeViewWrapper as="span" draggable data-drag-handle style={{ display: 'inline-block', lineHeight: 0, verticalAlign: 'middle' }} contentEditable={false}>
      <div style={{ position: 'relative', display: 'inline-block', maxWidth: '100%' }}>
        <img ref={imgRef} src={src} alt={alt ?? ''} style={imgStyle} />
        {selected && <div className={styles['img-resize-handle']} onMouseDown={onResizeStart} title="Drag to resize" />}
      </div>
    </NodeViewWrapper>
  );
};

export default ImageNodeView;
